import { type FunctionComponent, useRef } from 'react';

import { Button, Link } from '@dr.pogodin/react-utils';

import type { ImageAssetT } from 'utils';

import secondaryButtonTheme from 'themes/Button/admin/secondary-v2.scss';

import { AssetPreview, type RefT } from '../AssetPreview';

import assetPreviewTheme from './asset-preview.scss';

import S from './style.scss';

type PropsT = {
  image: File | ImageAssetT | null;
  setImage: (image: File | ImageAssetT | null) => void;
};

export const ProfilePhoto: FunctionComponent<PropsT> = ({
  image,
  setImage,
}) => {
  const previewRef = useRef<RefT>(null);
  return (
    <div className={S.container}>
      <h3>Profile photo</h3>
      <p>A single hero photo at the top of your public profile</p>
      <div styleName="content">
        <AssetPreview
          image={image}
          noDelete
          ref={previewRef}
          setImage={setImage}
          theme={assetPreviewTheme}
        />
        <div styleName="ops">
          <Button theme={secondaryButtonTheme} to="#your-library">
            Choose from library
          </Button>
          <p>
            or &zwnj;
            <Link
              onClick={() => {
                previewRef.current?.openPicker();
              }}
              to=""
            >
              upload new
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};
